import React, { useEffect } from 'react';
import { useI3Modal, I3ModalId } from '../context/I3ModalContext';
import '../styles/I3Modal.css';

interface I3ModalProps {
  id: Exclude<I3ModalId, null>;
  title: string;
  children: React.ReactNode;
}

const I3Modal: React.FC<I3ModalProps> = ({ id, title, children }) => {
  const { modalId, closeModal } = useI3Modal();

  useEffect(() => {
    if (modalId !== id) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [modalId, id, closeModal]);

  if (modalId !== id) return null;

  return (
    <div
      className="i3-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby={`i3-modal-title-${id}`}
      onClick={(e) => e.target === e.currentTarget && closeModal()}
    >
      <div className={`i3-modal i3-modal--${id}`}>
        <div className="i3-modal-header">
          <h2 id={`i3-modal-title-${id}`} className="i3-modal-title">{title}</h2>
          <button
            type="button"
            className="i3-modal-close"
            onClick={closeModal}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div
          className="i3-modal-body"
          onClick={(e) => {
            if ((e.target as HTMLElement).closest('a')) closeModal();
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default I3Modal;
